<div id="piechart">
  <mpro-zoom-controls></mpro-zoom-controls>
</div>
